import { render } from "./PostCTASection.vue?vue&type=template&id=62f004f1"
import script from "./PostCTASection.vue?vue&type=script&lang=js"
export * from "./PostCTASection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__